import PropTypes from 'prop-types';

const vendorProps = PropTypes.shape({
  email: PropTypes.string,
  legal_name: PropTypes.string,
  company_name: PropTypes.string,
});

export default vendorProps;
